mutation UnpublishVariationsXmlFeed(
    $campaignId: ID!
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier]
    $libraryFilters: InputLibraryFilters
    $platform: String!
) {
    unpublishVariationsXmlFeed(
        campaignId: $campaignId
        platform: $platform
        computedDeliverableIdentifiers: $computedDeliverableIdentifiers
        libraryFilters: $libraryFilters
    )
}
